<!--
* 组件名 : 悬浮图解文字
* 开发者 : JY
*
* 参数:
*  desc     { String }   required - 图解文字
*  isShow   { Boolean }           - 是否默认展开
*
* 事件:  null
* 
-->

<template>
  <div :class="['picture-info-wrap', shows]" ref="pictureGraph">
    <div class="info-content">
      <div class="info-body" ref="infoBody">
        <p v-html="desc" />
      </div>
      <v-btn v-if="isOver" @btnClick="expand_more">
        <v-icon>expand_more</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "picture-graph",
  props: {
    desc: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shows: "",
      boxH: "",
      isOpen: false,
      isOver: false,
    };
  },
  created() {
    if (this.isShow) {
      this.shows = "shows";
      this.isOpen = true;
    }
  },
  mounted() {
    this.boxH = this.get_box_height();
    this.is_show_expand_btn();
  },
  methods: {
    expand_more() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.shows = "shows";
        $(this.$refs.infoBody).velocity({
          height: this.$refs.infoBody.scrollHeight + 12,
        });
        //  旋转箭头
        $(this.$refs.infoBody)
          .next(".v-btn")
          .addClass("open");
      } else {
        $(this.$refs.infoBody).velocity(
          { height: this.boxH },
          {
            duration: 300,
            complete: () => {
              this.shows = "";
            },
          }
        );
        //  旋转箭头
        $(this.$refs.infoBody)
          .next(".v-btn")
          .removeClass("open");
      }
    },
    /**
     *  获得盒子初始高度
     */
    get_box_height() {
      return this.$refs.infoBody.clientHeight;
    },
    /**
     * 是否显示展开收起按钮
     */
    is_show_expand_btn() {
      let H = 0;
      $(this.$refs.pictureGraph)
        .find(".info-body p")
        .map((i, item) => {
          H += item.scrollHeight;
        });

      if (
        H >
        $(this.$refs.pictureGraph)
          .find(".info-body")
          .outerHeight()
      )
        this.isOver = true;
    },
  },
};
</script>

<style lang="scss">
.picture-info-wrap {
  max-width: 588px;
  height: auto;
  border-radius: 8px;
  overflow: hidden;
  background-color: rgba($color-black, 0.66);

  &:not(.shows) {
    .info-body {
      @include limit-line(2, 1.5);
    }
  }

  .info-content {
    padding: 20px 30px;

    .info-body {
      overflow: hidden;
    }

    p,
    .v-btn i {
      color: $color-white !important;
    }

    p {
      font-size: 16px;
      line-height: 1.5;
    }

    .v-btn {
      width: 282px;
      height: 24px;
      margin: 0 auto;
      justify-content: center;
      margin-bottom: -12px;
    }
  }

  .v-btn.open {
    i {
      transform: rotate(180deg);
    }
  }
}
</style>
